(ns ductile.time.format
  "A small convienience wrapper for consistent formatting of Dates & Times in Ductile"
  (:require #?(:clj [nextjournal.clerk :as clerk])
            [ductile.ui.locale :as locale])
  #?(:clj (:import [java.time ZoneId]
                   [java.time.format DateTimeFormatter FormatStyle])
     :cljs (:require-macros [nextjournal.clerk :as clerk])))


(defn ->str
  "Format a given `instant` with an optional `opts` map
  {:locale :en
   :format :datetime
   :style :short
   :zone \"Europe/Berlin\"}"
  ([instant] (->str {} instant))
  ([opts #?(:clj instant :cljs ^js instant)]
   (when instant
     (let [{:keys [locale format zone style]} (merge {:locale (locale/get-current-locale)
                                                      :format :datetime
                                                      :style :short
                                                      :zone "Europe/Berlin"}
                                                     opts)]
       #?(:clj (let [format-style (get {:short FormatStyle/SHORT
                                        :medium FormatStyle/MEDIUM
                                        :long FormatStyle/LONG
                                        :full FormatStyle/FULL} style)]
                 (.format (.atZone instant (ZoneId/of zone))
                          (-> (case format
                                :time     (DateTimeFormatter/ofLocalizedTime format-style)
                                :date     (DateTimeFormatter/ofLocalizedDate format-style)
                                :datetime (DateTimeFormatter/ofLocalizedDateTime format-style))
                              (.withLocale (locale/->java-locale locale)))))
          :cljs
          (let [instant (cond
                          (.-isLuxonDateTime instant) (.toJSDate instant)
                          (instance? js/goog.date.DateTime instant) (js/Date. (.valueOf instant))
                          :else instant)]
            (case format
              :time     (.toLocaleTimeString instant (locale/->iso-locale locale) #js {:timeZone zone
                                                                                       :timeStyle (name style)})
              :date     (.toLocaleDateString instant (locale/->iso-locale locale) #js {:timeZone zone
                                                                                       :dateStyle (name style)})
              :datetime (.toLocaleString instant (locale/->iso-locale locale) #js {:timeZone zone
                                                                                   :dateStyle (name style)
                                                                                   :timeStyle (name style)}))))))))

(clerk/example
  ;; a small dev-only viewer to render use Clerk's viewer api to call
  ;; `ductile.time.format/->str` on the cljs side
  ;;
  ;; not pretty atm, consider bringing in https://github.com/brandonbloom/backtick
  ;; to make it a bit less ugly
 (defn ->str-js-viewer [opts]
   {:transform-fn (clerk/update-val pr-str)
    :render-fn (list 'fn '[inst-str] (list 'nextjournal.clerk.viewer/html
                                           ['nextjournal.clerk.viewer/inspect
                                            (list 'ductile.time.format/->str
                                                  opts
                                                  '(read-string inst-str))]))})

 (defn ->str-js [opts instant]
   (clerk/with-viewer (->str-js-viewer opts)
     instant)))

(clerk/example
 (->str    {:format :time} nil)
 (->str-js {:format :time} nil)

 (->str    {:format :time :locale :en} (Instant/now))
 (->str-js {:format :time :locale :en} (Instant/now))

 (->str    {:format :time :locale :it} (Instant/now))
 (->str-js {:format :time :locale :it} (Instant/now))

 (->str    {:format :time :locale :de} (Instant/now))
 (->str-js {:format :time :locale :de} (Instant/now))

 (->str    {:format :time :locale :de :style :long} (Instant/now))
 (->str-js {:format :time :locale :de :style :long} (Instant/now)))

(clerk/example
 (->str    {:format :date} nil)
 (->str-js {:format :date} nil)

 (->str    {:format :date :locale :en} (Instant/now))
 (->str-js {:format :date :locale :en} (Instant/now))

 (->str    {:format :date :locale :it} (Instant/now))
 (->str-js {:format :date :locale :it} (Instant/now))

 (->str    {:format :date :locale :de} (Instant/now))
 (->str-js {:format :date :locale :de} (Instant/now))

 (->str    {:format :date :locale :de :style :long} (Instant/now))
 (->str-js {:format :date :locale :de :style :long} (Instant/now))

 (->str    {:format :date :locale :de :style :full} (Instant/now))
 (->str-js {:format :date :locale :de :style :full} (Instant/now)))

(clerk/example
 (->str    {:format :datetime} nil)
 (->str-js {:format :datetime} nil)

 (->str    {:format :datetime} (Instant/now))
 (->str-js {:format :datetime} (Instant/now))

 (->str    {:locale :it} (Instant/now))
 (->str-js {:locale :it} (Instant/now))

 (->str    {:locale :de} (Instant/now))
 (->str-js {:locale :de} (Instant/now))

 (->str    {:locale :de :style :long} (Instant/now))
 (->str-js {:locale :de :style :long} (Instant/now)))
